
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { ReplyType } from 'enums/ReplyType';
import { QuestionCategoryType } from 'enums/QuestionCategoryType';
import { QuestionReplyOptionModel } from './Entities.GormCrm.QuestionReplyOption';
import { QuestionTagModel } from './Entities.GormCrm.QuestionTag';
import { QuestionnaireQuestionProductModel } from './Entities.GormCrm.QuestionnaireQuestionProduct';
import { QuestionnaireQuestionReplyModel } from './Entities.GormCrm.QuestionnaireQuestionReply';
import { QuestionnaireQuestionModel } from './Entities.GormCrm.QuestionnaireQuestion';
import { Model, ModelProperty } from 'models/Model';


export class QuestionModel extends Model<QuestionModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'questionReplyInputType', type: 'ReplyType', languageString: 'question.property.questionReplyInputType' },
		{ name: 'category', type: 'QuestionCategoryType', languageString: 'question.property.category' },
		{ name: 'id', type: 'guid', languageString: 'question.property.id', isHidden: true },
		{ name: 'created', type: 'Date', languageString: 'question.property.created', isHidden: true },
		{ name: 'deleted', type: 'Date', languageString: 'question.property.deleted', isHidden: true },
		{ name: 'active', type: 'boolean', languageString: 'question.property.active' },
		{ name: 'questionText', type: 'string', languageString: 'question.property.questionText' },
		{ name: 'requiredNumberOfReplies', type: 'number', languageString: 'question.property.requiredNumberOfReplies' },
		{ name: 'questionReplyOptions', type: 'QuestionReplyOptionModel[]', languageString: 'question.property.questionReplyOptions', isHidden: true, isArray: true, isObject: true, new: () => { return new QuestionReplyOptionModel }, properties: () => { return QuestionReplyOptionModel.classProperties } },
		{ name: 'questionTags', type: 'QuestionTagModel[]', languageString: 'question.property.questionTags', isHidden: true, isArray: true, isObject: true, new: () => { return new QuestionTagModel }, properties: () => { return QuestionTagModel.classProperties } },
		{ name: 'questionnaireQuestionProducts', type: 'QuestionnaireQuestionProductModel[]', languageString: 'question.property.questionnaireQuestionProducts', isHidden: true, isArray: true, isObject: true, new: () => { return new QuestionnaireQuestionProductModel }, properties: () => { return QuestionnaireQuestionProductModel.classProperties } },
		{ name: 'questionnaireQuestionReplies', type: 'QuestionnaireQuestionReplyModel[]', languageString: 'question.property.questionnaireQuestionReplies', isHidden: true, isArray: true, isObject: true, new: () => { return new QuestionnaireQuestionReplyModel }, properties: () => { return QuestionnaireQuestionReplyModel.classProperties } },
		{ name: 'questionnaireQuestions', type: 'QuestionnaireQuestionModel[]', languageString: 'question.property.questionnaireQuestions', isHidden: true, isArray: true, isObject: true, new: () => { return new QuestionnaireQuestionModel }, properties: () => { return QuestionnaireQuestionModel.classProperties } }
	];
	[key: string]: any;
	
	public questionReplyInputType: ReplyType;
	public category?: QuestionCategoryType;
	public id?: string;
	public created?: Date;
	public deleted?: Date;
	public active: boolean;
	public questionText: string;
	public requiredNumberOfReplies?: number;
	public questionReplyOptions: QuestionReplyOptionModel[];
	public questionTags: QuestionTagModel[];
	public questionnaireQuestionProducts: QuestionnaireQuestionProductModel[];
	public questionnaireQuestionReplies: QuestionnaireQuestionReplyModel[];
	public questionnaireQuestions: QuestionnaireQuestionModel[];
    
	constructor(){
		super();
		this.questionReplyInputType = 0;
		this.category = undefined;
		this.id = undefined;
		this.created = undefined;
		this.deleted = undefined;
		this.active = false;
		this.questionText = '';
		this.requiredNumberOfReplies = undefined;
		this.questionReplyOptions = [];
		this.questionTags = [];
		this.questionnaireQuestionProducts = [];
		this.questionnaireQuestionReplies = [];
		this.questionnaireQuestions = [];
		
	}
	getProperties(){
		return QuestionModel.classProperties;
	}
}

